import { render, staticRenderFns } from "./Target.vue?vue&type=template&id=28378194&scoped=true&"
import script from "./Target.vue?vue&type=script&lang=js&"
export * from "./Target.vue?vue&type=script&lang=js&"
import style0 from "./Target.vue?vue&type=style&index=0&id=28378194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28378194",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28378194')) {
      api.createRecord('28378194', component.options)
    } else {
      api.reload('28378194', component.options)
    }
    module.hot.accept("./Target.vue?vue&type=template&id=28378194&scoped=true&", function () {
      api.rerender('28378194', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/Target.vue"
export default component.exports